// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZTElH","origen":"styles_origen__pmTGO","downloadContent":"styles_downloadContent__lgZxL"};